// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vHbm","top":"styles_top__1mlg0"};